import {
    apiRequest, 
    syaratJabatanList,
    syaratJabatanDetail

} from "../../../../../services/adapters/master/syaratJabatanService"

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", syaratJabatanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest('get', syaratJabatanDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }


}

export default IndexRepository
